export class Pushes {
    constructor(data) {
        this.message = data.message ?? data;
        this.status = data.status ?? data.result ?? 'success';
    }

    success() {
        this.status = 'success';
        return this;
    }

    error() {
        this.status = 'error';
        return this;
    }

    show() {
        if (this.message) {
            $('.js-push>p').text(this.message);
            $('.js-push').addClass('bg-' + this.status).addClass('push-message');

            setTimeout(function () {
                $('.js-push>p').text('');
                $('.js-push').removeClass('bg-' + this.status).removeClass('push-message');
            }, 7000);
        }
    }
}
